import AppHeader from '@/layout/AppHeader'
import StarterHeader from '@/layout/starter/StarterHeader'
import AppFooter from '@/layout/AppFooter'
import Main from '@/layout/Main'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [{
  path: '/',
  name: 'home',
  redirect: '/dashboard'
}, {
  path: '/login',
  name: 'login',
  meta: {
    title: '用户登录'
  },
  components: {
    header: StarterHeader,
    default: () => import('@/views/login/login.vue'),
    footer: AppFooter
  }
}, {
  path: '/recover',
  name: 'recover',
  meta: {
    title: '密码找回'
  },
  components: {
    header: StarterHeader,
    default: () => import('@/views/recover/recover.vue'),
    footer: AppFooter
  }
},
{
  path: '/register',
  name: 'register',
  meta: {
    title: '用户注册'
  },
  components: {
    header: StarterHeader,
    default: () => import('@/views/register/register.vue'),
    footer: AppFooter
  }
},
  // {
  //     path: '/repassword',
  //     name: 'repassword',
  //     meta: {
  //         title: '密码修改',
  //     },
  //     components: {
  //         header: AppHeader,
  //         default: () => import('@/views/repassword/index.vue'),
  //         footer: AppFooter
  //     }
  // },
{
  path: '/dashboard',
  name: 'dashboard',
  redirect: '/dashboard/index',
  meta: {
    title: '控制面板',
    className: 'shape-style-1 shape-default'
  },
  components: {
    header: AppHeader,
    default: Main,
    footer: AppFooter
  },
  children: [{
    path: '/dashboard/index',
    name: 'dashboard-index',
    meta: {
      title: '首页',
      icon: 'fa fa-home',
      className: 'shape-style-1 shape-default'
    },

    component: () => import('@/views/dashboard/index.vue')
  },
  {
    path: '/dashboard/plan',
    name: 'dashboard-plan',
    meta: {
      title: '订购新服务',
      icon: 'fas fa-bell',
      className: 'shape-style-1 shape-default'
    },
    component: () => import('@/views/dashboard/plan.vue')
  }
    // ,
    // {
    //   path: '/dashboard/renew',
    //   name: 'dashboard-renew',
    //   meta: {
    //     title: '续费当前套餐',
    //     icon: 'ni ni-calendar-grid-58',
    //     className: 'shape-style-1 shape-default'
    //   },
    //   component: () => import('@/views/dashboard/renew.vue')
    // }
  ]
},
{
  path: '/services',
  name: 'services',
  redirect: '/services/index',
  meta: {
    title: '我的服务',
    className: 'shape-style-1 bg-gradient-info'
  },
  components: {
    header: AppHeader,
    default: Main,
    footer: AppFooter
  },
  children: [{
    path: '/services/index',
    name: 'services-index',
    meta: {
      title: '我的服务',
      icon: 'fa fa-server',
      className: 'shape-style-1 bg-gradient-info'
    },
    component: () => import('@/views/services/index.vue')
  }]
},

{
  path: '/services/detail/:id',
  name: 'services-detail',
  meta: {
    title: '服务详情',
    icon: 'fa fa-first-order',
    hideInMenu: true,
    className: 'shape-style-1 bg-gradient-info'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/services/detail.vue'),
    footer: AppFooter
  }
},
{
  path: '/orders/stripe/pay/:id',
  name: 'orders-stripe-pay',
  meta: {
    title: '订单支付',
    icon: 'fa fa-first-order',
    hideInMenu: true,
    className: 'shape-style-1 bg-gradient-success'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/stripe/pay.vue'),
    footer: AppFooter
  }
},
{
  path: '/orders/a/stripe/pay/:id',
  name: 'orders-stripe-pay',
  meta: {
    title: '订单支付',
    icon: 'fa fa-first-order',
    hideInMenu: true,
    className: 'shape-style-1 bg-gradient-success'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/astripe/pay.vue'),
    footer: AppFooter
  }
},
{
  path: '/orders/pay/:id',
  name: 'orders-pay',
  meta: {
    title: '订单支付',
    icon: 'fa fa-first-order',
    hideInMenu: true,
    className: 'shape-style-1 bg-gradient-success'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/orders/pay.vue'),
    footer: AppFooter
  }
},
{
  path: '/orders/result',
  name: 'orders-result',
  meta: {
    title: '支付结果',
    icon: 'fa fa-first-order',
    hideInMenu: true,
    className: 'shape-style-1 bg-gradient-success'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/yuansfer/result.vue'),
    footer: AppFooter
  }
},
{
  path: '/orders',
  name: 'orders',
  redirect: '/orders/index',
  meta: {
    title: '我的订单',
    className: 'shape-style-1 bg-gradient-success'
  },
  components: {
    header: AppHeader,
    default: Main,
    footer: AppFooter
  },
  children: [
    {
      path: '/orders/index',
      name: 'orders-index',
      meta: {
        title: '我的订单',
        icon: 'fas fa-shopping-cart',
        className: 'shape-style-1 bg-gradient-success'
      },
      component: () => import('@/views/orders/index.vue')
    },
    {
      path: '/orders/checkout',
      name: 'orders-checkout',
      meta: {
        title: '订单结算',
        icon: 'fa fa-first-order',
        hideInMenu: true,
        className: 'shape-style-1 bg-gradient-success'
      },
      // component: () => import('@/views/orders/checkout.vue')
      component: () => import('@/views/yuansfer/checkout.vue')
    },
    {
      path: '/orders/stripe/checkout',
      name: 'orders-stripe-checkout',
      meta: {
        title: '订单结算',
        icon: 'fa fa-first-order',
        hideInMenu: true,
        className: 'shape-style-1 bg-gradient-success'
      },
      component: () => import('@/views/stripe/checkout.vue')
    },
    {
      path: '/orders/a/stripe/checkout',
      name: 'orders-stripe-checkout',
      meta: {
        title: '订单结算',
        icon: 'fa fa-first-order',
        hideInMenu: true,
        className: 'shape-style-1 bg-gradient-success'
      },
      component: () => import('@/views/astripe/checkout.vue')
    },
    {
      path: '/orders/yuansfer/checkout',
      name: 'orders-yuansfer-checkout',
      meta: {
        title: '订单结算',
        icon: 'fa fa-first-order',
        hideInMenu: true,
        className: 'shape-style-1 bg-gradient-success'
      },
      component: () => import('@/views/yuansfer/checkout.vue')
    }]
},
{
  path: '/tutorials',
  name: 'tutorials',
  meta: {
    title: '配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/index.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/android/v2rayng',
  name: 'v2rayng',
  meta: {
    title: 'V2RayNG - 安卓配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/android/v2rayng.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/android/cmfa',
  name: 'cmfa',
  meta: {
    title: 'Clash Meta for Android - 安卓配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/android/cmfa.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/android/nekobox',
  name: 'nekobox',
  meta: {
    title: 'NekoBox for Android - 安卓配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/android/nekobox.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/android/bifrostv',
  name: 'bifrostv',
  meta: {
    title: 'Bifrostv - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/android/bifrostv.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/ios/shadowrocket',
  name: 'shadowrocket',
  meta: {
    title: 'ShadowRocket - 苹果手机配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/ios/shadowrocket.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/ios/quantumult',
  name: 'quantumult',
  meta: {
    title: 'Quantumult - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/ios/quantumult.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/ios/kitsunebi',
  name: 'kitsunebi',
  meta: {
    title: 'Kitsunebi - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/ios/kitsunebi.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/win/clash',
  name: 'clash',
  meta: {
    title: 'Clash - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/win/clash.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/ios/sing-box',
  name: 'sing-box',
  meta: {
    title: 'Clash Verge - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/ios/sing-box.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/win/clash-verge',
  name: 'clash-verge',
  meta: {
    title: 'Clash Verge - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/win/clash-verge.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/win/v2rayn',
  name: 'v2rayn',
  meta: {
    title: 'V2RayN - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/win/v2rayn.vue'),
    footer: AppFooter
  }
},
{
  path: '/tutorials/macos/clashx',
  name: 'clashx',
  meta: {
    title: 'ClashX - 配置教程'
  },
  components: {
    header: AppHeader,
    default: () => import('@/views/tutorials/macos/clashx.vue'),
    footer: AppFooter
  }
}
]
